/**
 * Client Configuration
 * 
 * Uses environment variables set during build time by deploy-frontend.js
 * Falls back to agamim defaults for backward compatibility
 */

// Tenant info (set during build)
export const TENANT_ID = process.env.REACT_APP_TENANT_ID || 'agamim';
export const TENANT_NAME = process.env.REACT_APP_TENANT_NAME || 'Agamim 360';

// API Gateway (set during build, with runtime detection for local dev)
const hostname = window.location.hostname;
let API_BASE_URL;

if (hostname === 'localhost') {
  API_BASE_URL = 'http://localhost:3001';
} else if (hostname.startsWith('192.168.')) {
  API_BASE_URL = `http://${hostname}:3001`;
} else {
  // Use build-time API Gateway or default
  API_BASE_URL = process.env.REACT_APP_API_GATEWAY || 'https://5dfnn560ai.execute-api.eu-central-1.amazonaws.com';
}

export { API_BASE_URL };

// Legacy export for compatibility
export const API_GETWAY = process.env.REACT_APP_API_GATEWAY || 'https://5dfnn560ai.execute-api.eu-central-1.amazonaws.com';

// CloudFront domain (set during build)
export const CLOUDFRONT_DOMAIN = process.env.REACT_APP_CLOUDFRONT_DOMAIN || 'https://agamim360.com';

// Sentry DSN (set during build)
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || 'https://dfc251e63fe51a66b93830e6fcd09c37@o4509185972436992.ingest.de.sentry.io/4509185979056208';

// Branding
export const WELCOME_TEXT = `Welcome to ${TENANT_NAME}`;

// Prisma Studio URL (set during build)
export const PRISMA_STUDIO_URL = process.env.REACT_APP_PRISMA_STUDIO || 'https://n5ideatark.eu-central-1.awsapprunner.com/';
